import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptToolsGrid, DeptReportsGrid } from '../../Components/Common/DashboardKit';

/**
 * Supervisor module landing page.
 *
 * Owner (2026-10-05): the department pages list the modules the team uses and the KPI
 * reports that matter to it (DeptLandingSections); each card shows only when the person
 * may open it. The route is gated by dept.supervisor in allRoutes.js.
 */
const TOOLS = [
    "attendanceApprovals", "attendanceDeptFto", "attendanceDeptCoa",
    "epoMyApprovals", "epoSubordinates", "travelApprovals",
    "tasksDept", "tasksAssigned", "tasksActivity", "projectsAwaiting", "whosIn", "orgChart",
];

const Supervisor = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-user-settings-line"
                        eyebrow="Oversight"
                        title="Supervisor"
                        subtitle="Team oversight and approvals"
                        tone="violet"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Supervisor" },
                        ]}
                    />

                    <DeptToolsGrid
                        ids={TOOLS}
                        title="Approvals & oversight"
                        description="What needs your decision, and your team's work"
                        icon="ri-inbox-archive-line"
                    />
                    <DeptReportsGrid ids={[]} />

                    <ComingSoonCard
                        compact
                        icon="ri-user-settings-line"
                        title="More for Supervisors later"
                        message="Ideas for later: direct-report attendance overviews and team KPI rollups. The cards above are live today."
                        tone="primary"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Supervisor;
